module.exports = __webpack_public_path__ + "img/neera-eco-kit.c881ed72.svg";